var _rect, _path, _path2, _circle, _ellipse, _circle2, _ellipse2, _ellipse3, _circle3, _circle4, _circle5, _ellipse4, _ellipse5, _ellipse6, _circle6, _ellipse7, _circle7, _path3, _path4, _ellipse8, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.602 245.117C202.905 243.458 225.821 242.134 235.054 250.109C226.011 250.853 205.949 255.557 198.039 268.425",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.503 245.117C332.2 243.458 309.284 242.134 300.051 250.109C309.093 250.853 329.156 255.557 337.066 268.425",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.765,
    cy: 168.707,
    r: 12,
    fill: "#666666"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 382.265,
    cy: 340.707,
    rx: 19.5,
    ry: 20,
    fill: "#666666"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.765,
    cy: 339.707,
    r: 12,
    fill: "#666666"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.7649,
    cy: 255.207,
    rx: 16,
    ry: 16.5,
    fill: "#666666"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.265,
    cy: 211.707,
    rx: 16.5,
    ry: 16,
    fill: "#666666"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.765,
    cy: 165.707,
    r: 12,
    fill: "#666666"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.765,
    cy: 280.707,
    r: 12,
    fill: "#666666"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.265,
    cy: 174.207,
    r: 17.5,
    fill: "#666666"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 459.765,
    cy: 272.207,
    rx: 9,
    ry: 8.5,
    fill: "#666666"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.265,
    cy: 208.707,
    rx: 9.5,
    ry: 9,
    fill: "#666666"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.765,
    cy: 378.207,
    rx: 9,
    ry: 8.5,
    fill: "#666666"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.765,
    cy: 364.707,
    r: 17,
    fill: "#666666"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.265,
    cy: 252.707,
    rx: 8.5,
    ry: 8,
    fill: "#666666"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.265,
    cy: 358.207,
    r: 19.5,
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.334 144C126.862 144.941 109.751 150.923 106.199 167.279C105.906 168.627 104.84 169.7 103.475 169.906C83.1561 172.976 50.4202 187.728 63.7092 225.683C64.1268 226.875 63.8117 228.229 62.8815 229.085C43.6407 246.774 20.2658 287.105 68.6751 319.147C69.6684 319.805 70.23 320.99 70.0839 322.172C67.1609 345.834 75.2104 386.954 130.15 376.407C130.318 376.374 130.491 376.326 130.651 376.264C151.248 368.319 171.917 347.636 160.933 304.483",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M394.134 144C402.606 144.941 419.718 150.923 423.269 167.279C423.562 168.627 424.629 169.7 425.993 169.906C446.312 172.976 479.048 187.728 465.759 225.683C465.341 226.875 465.657 228.229 466.587 229.085C485.828 246.774 509.202 287.105 460.793 319.147C459.8 319.805 459.238 320.99 459.384 322.172C462.307 345.834 454.258 386.954 399.319 376.407C399.15 376.374 398.978 376.326 398.817 376.264C378.22 368.319 357.551 347.636 368.536 304.483",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.179,
    cy: 287.297,
    rx: 32.9028,
    ry: 18.1301,
    fill: "#1C1B1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.673 322.271C212.535 300.042 273.64 268.716 335.685 322.271",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M265.112 305.594V329.418",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.765 349.707C247.592 342.183 267.525 331.581 287.765 349.707",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/내과_홍역.ba9d3f4721b210d0558b92e40ecf9008.svg";
export { ForwardRef as ReactComponent };